import {createListFromObject} from "../../Utilities/Types/listUtilities";

export const ROLES = {
    SystemAdmin: 1,
    FimcAdmin: 2,
    Admin: 4, 
    EseDirector: 3, 
    Patron: 5,
    Delegate: 6,
    StudentViewer: 7,
    AphViewer:8,
    LoanLibraryViewer:9,
    BraillerViewer:10
};

export const PATRON_ROLE = {
    Parent: 1,
    SchoolDistrictEmployee: 2,
    CharterSchoolEmployee: 3,
    PrivateSchoolEmployee: 4,
    DbsOrAgencyStaffMember: 5,
    Fimc: 6,
    Other: 10
};

export const PATRON_SUBTYPE = {
    HomeSchool: 1,
    Private: 2,
    Charter: 3,
    Public: 4,
    EseDirector: 5,
    Administrator: 6,
    DistrictPersonnel: 7,
    TviAndOrOnM: 8,
    Paraprofessional: 9,
    GenedEse: 10,
    SchoolPsychologist: 11,
    Lats: 12,
    SchoolPersonnel: 13,
    StaffMember: 14,
    ServiceProvider: 15,
    BusinessCommunityMember: 16,
    IdeaProjectStaff: 18,
    CollegeUniversityStudent: 19,
    CollegeUniversityFaculty: 20,
    FdoeStaff: 21,
    Manager: 22,
    AccessibleMediaProducer: 23,
    BrailleSpecialist: 24,
    SchoolAdministrator: 25
};

export const PATRON_SUBTYPE_LIST = createListFromObject(PATRON_SUBTYPE);
